  export const EnableOrDisable= (etat) => {
    return {
      type: "disableView",
      payload:etat
    };
  };